import React, {useState} from 'react';
import style from "./ConfirmDocs.module.css"
import VerificationIcon from "../../shared/icons/VerificationIcon";
import UploadIcon from "../../shared/icons/UploadIcon";
import cn from "classnames"
import CheckmarkIcon from "../../shared/icons/CheckmarkIcon";
import {File} from "../../../services";
import {toast} from "react-toastify";
import {useAmplitude} from "../../../hooks/useAmplitude";
import {requestErrorDisplay} from "../../../utils";
import { useTranslation, Trans } from 'react-i18next'; // Import useTranslation and Trans

const ConfirmDocs = ({ userId, updateData, onClose }) => {
  const { t } = useTranslation(); // Initialize useTranslation
  const { amplitude } = useAmplitude()
  const [isLoading, setLoading] = useState(false);
  const [isSuccess, setSuccess] = useState(false);
  const [registrationCertificate, setRegistrationCertificate] = useState(null);
  const [orderOfAppointment, setOrderOfAppointment] = useState(null);

  // TODO refactoring
  const onHandleSubmit = () => {
    console.log('files data ==>', registrationCertificate, orderOfAppointment);
    if (!registrationCertificate || !orderOfAppointment || isLoading) {
      toast.error(t('confirmDocs.toast.uploadError')); // Use translation
      return
    }

    // send amplitude track
    amplitude.sendDocsToVerify()

    setLoading(true)
    const formData1 = new FormData();
    formData1.append("file", registrationCertificate);
    formData1.append("type", 0)
    formData1.append("userId", userId)
    const formData2 = new FormData();
    formData2.append("file", orderOfAppointment);
    formData2.append("type", 2);
    formData2.append("userId", userId);
    Promise.all([ File.add(formData1), File.add(formData2) ])
      .then(responses => {
      if (responses && responses.length && responses[0].status == 200 && responses[1].status == 200) {
        // setLoading(false);
        setSuccess(true)
        updateData()
      } else {
        setRegistrationCertificate(null);
        setOrderOfAppointment(null);
        toast.error(t('verificationForm.fileUpload.error')); // Reuse translation
      }
    }).catch(error => {
      requestErrorDisplay(error, t, 'verificationForm.fileUpload.error'); // Reuse translation and pass t
      setLoading(false);
    }).finally(() => {
      setRegistrationCertificate()
      setOrderOfAppointment()
      setLoading(false);
    });
  }

  if (isSuccess) {
    return (
      <div className={style.confirm}>

        {/* Title */}
        <h2 className={style.title}>{t('confirmDocs.successTitle')}</h2>

        {/* Summary */}
        <p className={style.summary}>
          {t('confirmDocs.successSummary')}
        </p>

        {/* Submit */}
        <button
          className={cn(style.btn)}
          onClick={() => onClose()}
        >
          {t('confirmDocs.buttonClose')}
        </button>
      </div>
    )
  }
  return (
      <div className={style.confirm}>

        {/* Icon */}
        <VerificationIcon className={style.icon} />

        {/* Title */}
        <h2 className={style.title}>{t('confirmDocs.verificationTitle')}</h2>

        {/* Summary */}
        {/* Using dangerouslySetInnerHTML because the key contains <br/> */}
        <p className={style.summary} dangerouslySetInnerHTML={{ __html: t('confirmDocs.verificationSummary') }} />

        {/* First input */}
      <label
        htmlFor="first"
        className={cn(style.list, { [style.uploaded]: !!registrationCertificate })}
        data-file-name={registrationCertificate && registrationCertificate.name}
      >
        <div>
          <p>{t('verificationForm.fileUpload.registrationCertificateLabel')}</p> {/* Reuse translation */}
          <span>
            { registrationCertificate ? t('confirmDocs.button.replace') : t('confirmDocs.button.upload') }
          </span>
          <input type="file" id="first" accept="image/gif,image/png,image/jpeg,application/pdf" onChange={(event) => setRegistrationCertificate(event.target.files[0])} />
        </div>
        { registrationCertificate ? <CheckmarkIcon /> : <UploadIcon /> }
      </label>

      {/* Second input */}
      <label
        htmlFor="last"
        className={cn(style.list, { [style.uploaded]: !!orderOfAppointment })}
        data-file-name={orderOfAppointment && orderOfAppointment.name}
      >
        <div>
          <p>{t('verificationForm.fileUpload.orderOfAppointmentLabel')}</p> {/* Reuse translation */}
          <span>
            { orderOfAppointment ? t('confirmDocs.button.replace') : t('confirmDocs.button.upload') }
          </span>
          <input type="file" id="last" accept="image/gif,image/png,image/jpeg,application/pdf" onChange={(event) => setOrderOfAppointment(event.target.files[0])} />
        </div>
        { orderOfAppointment ? <CheckmarkIcon /> : <UploadIcon /> }
      </label>

      {/* Summary */}
      {/* Using Trans component for embedded link */}
      <p className={cn(style.summary2, { [style.hide]: !registrationCertificate || !orderOfAppointment })}>
        <Trans i18nKey="confirmDocs.termsAgreement">
          Нажимая на кнопку, вы подтверждаете, что согласны с <a href="https://app.biny.co/privacy-policy.pdf" target="_blank" rel="noopener noreferrer">Условиями использования</a> сервиса Biny
        </Trans>
      </p>

      {/* Submit */}
      <button
        className={cn(style.btn, {
          [style.hide]: !registrationCertificate || !orderOfAppointment,
          [style.loading]: isLoading })
        }
        onClick={() => onHandleSubmit()}
      >
        {t('confirmDocs.buttonSend')}
      </button>
    </div>
  );
};

export default ConfirmDocs;
